import React, {Component} from 'react';
import _ from 'lodash';
import Loader from 'react-loader-spinner';
import Pagination from "react-js-pagination";
import {Checkbox, Form, Grid} from 'semantic-ui-react'
import Dropdown from "semantic-ui-react/dist/commonjs/modules/Dropdown/Dropdown";
import Slider from '@material-ui/core/Slider';
import TextField from "@material-ui/core/TextField";
import {Autocomplete} from "@material-ui/lab";
import {i18n} from "../i18n";
import JobAboModal from "./JobAboModal";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import { serviceBaseUrl } from '../config.js'

import { withStyles } from "@material-ui/core/styles";

function sendResizeMessage() {
    const height = Math.max(document.body.scrollHeight, document.body.offsetHeight);
    window.parent.postMessage('module-iframe-resize->' + height, '*');
}

function parseUrlFilters(urlSearchParams = '?') {
    const paramsString = urlSearchParams.startsWith('?') ? urlSearchParams.substr(1) : urlSearchParams
    return paramsString.split('&')
        .map(pairString => pairString.split('='))
        .reduce((filters, [filter, value]) => {
            if (!Reflect.has(filters, filter))
                filters[filter] = []
            filters[filter].push(...(value || '').split(','))
            return filters
        }, {})
}
const CustomAutocomplete = withStyles({
    tag: {
        position: "relative",
        zIndex: 0,
        "& .MuiChip-label": {
            color: "#fff"
        },
        "& .MuiChip-deleteIcon": {
            opacity: "0"
        },
        "&:after": {
            content: '"\\00d7"',
            right: 20,
            top: 0,
            fontSize: "20px",
            position: "relative",
            zIndex: -1
        }
    }
})(Autocomplete);

const attributeType = {
    berufsgruppe: '10',
    arbeitszeiten: '25',
    position: '30',
    standort: '65',
    fachbereich: '70',
    haufigestellen: '110',
};

const getBerufsGruppe = data => {
    const groups = data.attributes.find(attribute => attribute.id === attributeType.berufsgruppe);
    const getChildren = (value) => Object.entries(data.attributes
        .find(attribute => attribute.id === `${attributeType.berufsgruppe}_${value}`)?.values || [])
        .map(([childValue, title]) => ({title: title+" ", value: childValue, group: value}))
        .sort((child1, child2) => child1.title.localeCompare(child2.title));
    try {
        const parents = Object.entries(groups.values).sort(([id1, title1], [id2, title2]) => title1.localeCompare(title2))
        const result = parents.reduce((items, [value, title]) => {
            const children = getChildren(value, title);
            return [...items, {value, title, type: 'group'}, ...children];
        }, []);
        return result;
    } catch (e) {
        console.error(e);
        return [];
    }
};

class JobList extends Component {
    state = {
        activeIndex: 1,
        activePage: 1,
        limit: 12,
        isLoading: true,
        jobsTotal: "",
        jobs: [],
        error: null,
        value: '',
        berufsgruppeFilter: [],
        arbeitszeitenFilter: {},
        positionFilter: {},
        standortFilter: {},
        fachbereichFilter: false,
        haufigGesuchteStellen: {},
        filterValues: {
            searchTerm: "",
            berufsgruppeFilter: [],
            arbeitszeitenFilter: "",
            positionFilter: "",
            standortFilter: [],
            fachbereichFilter: [],
            haufigGesuchteStellen: "",
            workload: ""
        },
    };

    async fetchJobs({searchTerm, berufsgruppeFilter, arbeitszeitenFilter, positionFilter, standortFilter, fachbereichFilter, haufigGesuchteStellen, workload}, pageNumber = 1) {
        this.setState({activePage: pageNumber});

        const searchParams = [];

        if (searchTerm) {
            searchParams.push(`q=${searchTerm}`)
        }

        if (berufsgruppeFilter.length) {
            searchParams.push(`f=${attributeType.berufsgruppe}:${berufsgruppeFilter.map(item => item.value).join(',')}`)
        }

        if (arbeitszeitenFilter) {
            searchParams.push(`f=${attributeType.arbeitszeiten}:${arbeitszeitenFilter}`)
        }

        if (positionFilter) {
            searchParams.push(`f=${attributeType.position}:${positionFilter}`)
        }

        if (standortFilter.length) {
            searchParams.push(`f=${attributeType.standort}:${standortFilter.map(item => item).join(',')}`)
        }

        if (fachbereichFilter.length) {
            searchParams.push(`f=${attributeType.fachbereich}:${fachbereichFilter.join(',')}`)
        }

        if (haufigGesuchteStellen) {
            searchParams.push(`f=${attributeType.haufigestellen}:${haufigGesuchteStellen}`)
        }

        if (workload) {
            searchParams.push(`workload=${workload}`)
        }

        const offsetPaging = pageNumber * this.state.limit - this.state.limit;

        const result = await fetch(`${serviceBaseUrl}/medium/1001134/jobs?lang=${i18n.lang}&limit=${this.state.limit}&${searchParams.join("&")}&offset=${offsetPaging}`)
        const resultJson = await result.json();
        return resultJson
    }

    handlePageChange = pageNumber => {
        this.setState({activePage: pageNumber});
        this.fetchJobs(this.state.filterValues, pageNumber).then(data => this.setState({
            isLoading: false,
            jobs: data.jobs,
            jobsTotal: data.total
        })).catch(error => this.setState({isLoading: false, error}));
    };

    fetchFilters() {
        return fetch(`${serviceBaseUrl}/medium/1001134/attributes/?lang=${i18n.lang}`)
            .then(response => response.json())
            .then(data => new Promise((resolve) => {
                    this.setState({
                        berufsgruppeFilter: getBerufsGruppe(data),
                        arbeitszeitenFilter: data.attributes.find(attribute => attribute.id === attributeType.arbeitszeiten),
                        positionFilter: data.attributes.find(attribute => attribute.id === attributeType.position),
                        standortFilter: data.attributes.find(attribute => attribute.id === attributeType.standort),
                        fachbereichFilter: data.attributes.find(attribute => attribute.id === attributeType.fachbereich),
                        haufigestellen: data.attributes.find(attribute => attribute.id === attributeType.haufigestellen),
                        isLoading: false,
                    }, () => resolve(data))
                }
            ))
            .catch(error => this.setState({error, isLoading: false}));
    };

    fetchSuggestions() {
        //todo  Add suggestions
    }

    resetFilters() {
        this.setState({
            filterValues: {
                searchTerm: "",
                berufsgruppeFilter: [],
                arbeitszeitenFilter: "",
                positionFilter: "",
                standortFilter: [],
                fachbereichFilter: [],
                haufigGesuchteStellen: "",
                workload: ""
            },
            value: '',
            isLoading: true,
        }, () => {
            this.fetchJobs(this.state.filterValues)
                .then(data => this.setState({
                    isLoading: false,
                    jobs: data.jobs,
                    jobsTotal: data.total
                }))
                .catch(error => this.setState({isLoading: false, error}));
        });
    }

    onSearchTermChange(e, value) {
        e.persist();
        this.setState({value: e.target.value.toLowerCase()})
        if (!this.debouncedFn) {
            this.debouncedFn = _.debounce(() => {
                const filters = {...this.state.filterValues};
                filters.searchTerm = e.target.value.toLowerCase();
                this.setState({isLoading: true, filterValues: filters});
                this.fetchJobs(filters).then(data => this.setState({
                    isLoading: false,
                    jobs: data.jobs,
                    jobsTotal: data.total
                })).catch(error => this.setState({isLoading: false, error}));
            }, 500);
        }
        this.debouncedFn();
    };

    onJobGroupSelected(e, value, type, detail) {
        const filterValues = {...this.state.filterValues};
        const option = detail?.option;

        if (option && option.type === 'group') {
            const groupItems = this.state.berufsgruppeFilter.filter(item => item.group === option.value && type !== 'group');
            const selectedGroupsItems = filterValues.berufsgruppeFilter.filter(item => item.group === option.value && type !== 'group');
            if (groupItems.length === selectedGroupsItems.length) {
                // If all group items are selected, deselect:
                filterValues.berufsgruppeFilter = value.filter(option => !selectedGroupsItems.includes(option)).filter(item => item.type !== 'group');
            } else {
                // otherwise select all:
                const selection = filterValues.berufsgruppeFilter = [...filterValues.berufsgruppeFilter, ...groupItems].filter(item => item.type !== 'group');
                // ...and deduplicate:
                filterValues.berufsgruppeFilter = Array.from(new Set(selection));
            }
        } else {
            filterValues.berufsgruppeFilter = value;
        }
        this.setState({isLoading: true, filterValues: filterValues});
        this.fetchJobs(filterValues).then(data => this.setState({
            isLoading: false,
            jobs: data.jobs,
            jobsTotal: data.total
        })).catch(error => this.setState({isLoading: false, error}));
    }

    onArbeitszeitenFilterChange(e, {value, checked}) {
        const filters = {...this.state.filterValues};
        const filterValue = new Set(filters.arbeitszeitenFilter.split(',').filter(item => item));
        if (checked)
            filterValue.add(value);
        else
            filterValue.delete(value);
        filters.arbeitszeitenFilter = Array.from(filterValue).join(',');
        this.setState({isLoading: true, filterValues: filters});
        this.fetchJobs(filters).then(data => this.setState({
            isLoading: false,
            jobs: data.jobs,
            jobsTotal: data.total
        })).catch(error => this.setState({isLoading: false, error}));
    }

    onPositionFilterChange(e, {value, checked}) {
        const filters = {...this.state.filterValues};
        const filterValue = new Set(filters.positionFilter.split(',').filter(item => item));
        if (checked)
            filterValue.add(value);
        else
            filterValue.delete(value);
        filters.positionFilter = Array.from(filterValue).join(',');
        this.setState({isLoading: true, filterValues: filters});
        this.fetchJobs(filters).then(data => this.setState({
            isLoading: false,
            jobs: data.jobs,
            jobsTotal: data.total
        })).catch(error => this.setState({isLoading: false, error}));
    }

    onStandortFilterChange(e, {value}) {
        const filters = {...this.state.filterValues};
        filters.standortFilter = value;
        this.setState({isLoading: true, filterValues: filters});
        this.fetchJobs(filters).then(data => this.setState({
            isLoading: false,
            jobs: data.jobs,
            jobsTotal: data.total
        })).catch(error => this.setState({isLoading: false, error}));
    }

    onFachbereichFilterChange(e, {value}) {
        const filters = {...this.state.filterValues};
        filters.fachbereichFilter = value;
        this.setState({isLoading: true, filterValues: filters});
        this.fetchJobs(filters).then(data => this.setState({
            isLoading: false,
            jobs: data.jobs,
            jobsTotal: data.total
        })).catch(error => this.setState({isLoading: false, error}));
    }

    onWorkloadChange(e, value) {
        const filters = {...this.state.filterValues};
        filters.workload = value;
        this.setState({isLoading: true, filterValues: filters});
        this.fetchJobs(filters).then(data => this.setState({
            isLoading: false,
            jobs: data.jobs,
            jobsTotal: data.total
        })).catch(error => this.setState({isLoading: false, error}));
    }

    // onHaufigGesuchteChange () {
    //     const filters = {...this.state.filterValues};
    //     filters.haufigGesuchteStellen = filters.haufigGesuchteStellen === "1" ? "" : "1";
    //     this.setState({isLoading: true, filterValues: filters});
    //     this.fetchJobs(filters).then(data => this.setState({
    //         isLoading: false,
    //         jobs: data.jobs,
    //         jobsTotal: data.total
    //     })).catch(error => this.setState({isLoading: false, error}));
    // };

    componentDidMount() {
        this.setState({isLoading: true});
        this.fetchSuggestions();
        this.fetchFilters()
            .then(() => {
                // Set pre-defined filters:
                const preDefinedFilters = parseUrlFilters(location.search);
                const filterValues = {};
                if (preDefinedFilters.searchTerm) filterValues.searchTerm = preDefinedFilters.searchTerm[0];
                if (preDefinedFilters.filter_10 !== undefined) filterValues.berufsgruppeFilter = this.state.berufsgruppeFilter.filter(entry => preDefinedFilters.filter_10.some(id => entry.value === id))
                if (preDefinedFilters.filter_25 !== undefined) filterValues.arbeitszeitenFilter = preDefinedFilters.filter_25[0];
                if (preDefinedFilters.filter_30 !== undefined) filterValues.positionFilter = preDefinedFilters.filter_30[0];
                if (preDefinedFilters.filter_65 !== undefined) filterValues.standortFilter = preDefinedFilters.filter_65;
                if (preDefinedFilters.filter_70 !== undefined) filterValues.fachbereichFilter = preDefinedFilters.filter_70;
                if (preDefinedFilters.filter_110 !== undefined) filterValues.haufigGesuchteStellen = preDefinedFilters.filter_110[0];
                if (preDefinedFilters.workload) filterValues.workload = preDefinedFilters.workload;

                this.setState({
                    value: filterValues.searchTerm || '',
                    filterValues: {...this.state.filterValues, ...filterValues},
                    isLoading: true
                });
                this.fetchJobs(this.state.filterValues).then(data => this.setState({
                    isLoading: false,
                    jobs: data.jobs,
                    jobsTotal: data.total
                })).catch(error => this.setState({isLoading: false, error}));
            });
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.jobs !== this.state.jobs) {
            sendResizeMessage()
        }
    }

    render() {
        const {isLoading, jobs, jobsTotal} = this.state;

        const marks = [
            {
                value: 10,
                label: '10%',
            },
            {
                value: 20,
                label: '20%',
            },
            {
                value: 30,
                label: '30%',
            },
            {
                value: 40,
                label: '40%',
            },
            {
                value: 50,
                label: '50%',
            },
            {
                value: 60,
                label: '60%',
            },
            {
                value: 70,
                label: '70%',
            },
            {
                value: 80,
                label: '80%',
            },
            {
                value: 90,
                label: '90%',
            },
            {
                value: 100,
                label: '100%',
            },
        ];

        function valuetext(value) {
            return `${value}%`;
        }

        function getSlug(str) {
            str = str.replace(/^\s+|\s+$/g, ''); // trim
            str = str.toLowerCase();

            // remove accents, swap ñ for n, etc
            var from = "àáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
            var to   = "aaaaaeeeeiiiioooouuuunc------";

            for (var i=0, l=from.length ; i<l ; i++) {
                str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
            }

            str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
                .replace(/\s+/g, '-') // collapse whitespace and replace by -
                .replace(/-+/g, '-'); // collapse dashes

            return str;
        }

        return (
            <div>
                {/* Filter */}

                <Accordion onChange={() => setTimeout(function(){ sendResizeMessage() },1000)}>
                    <AccordionSummary
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        className={"topSection"}
                    >
                        <div className={"ui left icon input"}>
                            <i aria-hidden="true" className={"search icon"}/>
                            <input className={"inputField"}
                                   type="text"
                                   placeholder={i18n.translations.searchPlaceholder}
                                   value={this.state.value}
                                   onChange={this.onSearchTermChange.bind(this)}
                            />
                        </div>
                        <button className={"button button--secondary filter"} aria-label="Button">{i18n.translations.showFilters}</button>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div className={"panel"}>
                            {/*Workload Filters*/}
                            <div>
                                <br/><br/>
                                <div className={"filterTitle"}>{i18n.translations.workloadFilter}</div>
                                <Slider
                                    className={"pensumSlider"}
                                    aria-labelledby="track-inverted-range-slider"
                                    getAriaValueText={valuetext}
                                    min={10}
                                    defaultValue={[10, 100]}
                                    marks={marks}
                                    step={10}
                                    valueLabelDisplay="on"
                                    onChangeCommitted={this.onWorkloadChange.bind(this)}
                                />
                            </div>

                            {/*Checkbox Filters*/}
                            <div>
                                <div className={"checkboxFilters"}>
                                    <Form className={"checkboxes arbeitszeitenFilter"}>
                                        <div className={"filterTitle"}>{i18n.translations.workingHours}</div>
                                        {
                                            Object.entries(this.state.arbeitszeitenFilter.values || {}).map(([key, value]) =>
                                                (
                                                    <Form.Field key={key}>
                                                        <Checkbox
                                                            label={value}
                                                            name='checkboxRadioGroup'
                                                            value={key}
                                                            checked={this.state.filterValues.arbeitszeitenFilter.split(',').includes(key)}
                                                            onChange={this.onArbeitszeitenFilterChange.bind(this)}
                                                        />
                                                    </Form.Field>
                                                )
                                            )
                                        }
                                    </Form>
                                    <Form className={"checkboxes positionFilter"}>
                                        <div className={"filterTitle"}>{i18n.translations.position}</div>
                                        {
                                            Object.entries(this.state.positionFilter.values || {}).map(([key, value]) =>
                                                (
                                                    <Form.Field key={key}>
                                                        <Checkbox
                                                            label={value}
                                                            name='checkboxRadioGroup'
                                                            value={key}
                                                            checked={this.state.filterValues.positionFilter.split(',').includes(key)}
                                                            onChange={this.onPositionFilterChange.bind(this)}
                                                        />
                                                    </Form.Field>
                                                )
                                            )
                                        }
                                    </Form>
                                </div>
                            </div>

                            {/*Dropdown Filters*/}
                            <Grid columns={3}>
                                <Grid.Row className={"dropdownFilters"}>
                                    <Grid.Column>
                                        <Dropdown
                                            closeOnChange={true}
                                            className={"dropdown standortSelect"}
                                            clearable
                                            fluid
                                            multiple
                                            search
                                            selection
                                            value={this.state.filterValues.standortFilter}
                                            options={Object.entries(this.state.standortFilter.values || {}).map(([key, value]) => ({
                                                key,
                                                value: key,
                                                text: value
                                            })).sort((a,b) => a.text.localeCompare(b.text))}
                                            onChange={this.onStandortFilterChange.bind(this)}
                                            placeholder={i18n.translations.workplace}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Dropdown
                                            closeOnChange={true}
                                            className={"dropdown standortSelect"}
                                            clearable
                                            fluid
                                            multiple
                                            search
                                            selection
                                            value={this.state.filterValues.fachbereichFilter}
                                            options={Object.entries(this.state.fachbereichFilter.values || {}).map(([key, value]) => ({
                                                key,
                                                value: key,
                                                text: value
                                            })).sort((a,b) => a.text.localeCompare(b.text))}
                                            onChange={this.onFachbereichFilterChange.bind(this)}
                                            placeholder={i18n.translations.workfield}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <CustomAutocomplete
                                            role={"comebox"}
                                            className={"ui fluid multiple search selection standortSelect"}
                                            multiple
                                            id="berufsGruppe"
                                            options={this.state.berufsgruppeFilter}
                                            value={this.state.filterValues.berufsgruppeFilter}
                                            disableCloseOnSelect
                                            onChange={this.onJobGroupSelected.bind(this)}
                                            getOptionLabel={option => option.title}
                                            renderOption={(option, {selected}) =>
                                                option.type === "group" ? (
                                                    <div className={"groupHeader"}>{option.title}</div>
                                                ) : (
                                                    <React.Fragment>
                                                        <div className={"groupElement"} >{option.title}</div>
                                                    </React.Fragment>
                                                )
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    id="befufsGruppeFilterInput"
                                                    variant="outlined"
                                                    placeholder={i18n.translations.jobGroup}
                                                />)}
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>

                        </div>
                    </AccordionDetails>
                </Accordion>


                <Grid columns={3} className={"threeButtonSection"}>
                    <Grid.Row>
                        <Grid.Column>
                            <JobAboModal />
                        </Grid.Column>
                        <Grid.Column>

                        </Grid.Column>
                        <Grid.Column>
                            <button className="tag__button filterReset" onClick={this.resetFilters.bind(this)}>
                                <span className="tag__label">{i18n.translations.resetFilters}</span>
                            </button>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>





                <hr className={"separatorFilters"}/>


                {/* Joblist */}

                <div className={"jobListContainer"}>
                    <ul className={"list__list"}>
                        {!isLoading ? (
                            jobs.map(job => {
                                return (
                                    <li className={"job js-iv job--was-visible job--visible job--complete"}
                                        key={job.id}>
                                        <a target="_blank" className={"job__link"} rel="noopener noreferrer"
                                           href={"https://jobs.usz.ch/offene-stellen/" + getSlug(job.title) + "/" + job.viewkey}>
                                            <div className={"job__left"}>
                                                <h5 className={"job__field"}>{job.attributes[10].join(', ')}</h5>
                                                <h3 className={"job__title"}>{job.title}</h3>
                                            </div>
                                            <div className={"job__center"}>
                                                <strong>{i18n.translations.field}</strong>
                                                <span className={"job__category"}>{job.attributes[70]}</span>
                                            </div>
                                            <div className={"job__right"}>
                                                <span className={"job__button"}/>
                                            </div>
                                        </a>
                                    </li>
                                );
                            })
                        ) : (
                            <div className={"loading"}>
                                <div><b>Loading...</b></div>
                                <Loader
                                    type="ThreeDots"
                                    color="#005ea8"
                                    height={100}
                                    width={100}
                                />
                            </div>
                        )}
                    </ul>
                </div>


                <div className={"containerPaging"}>
                    <Pagination
                        totalItemsCount={jobsTotal}
                        onChange={this.handlePageChange}
                        activePage={this.state.activePage}
                        itemsCountPerPage={this.state.limit}
                        pageRangeDisplayed={8}
                        itemClass={"pagingPage"}
                        hideFirstLastPages={true}
                        itemClassPrev={"back"}
                        itemClassNext={"next"}
                        prevPageText={"←"}
                        nextPageText={"→"}
                    />
                </div>


            </div>
        );
    };
}

export default JobList;
